import { useCallback } from "react";

export const useScrollTo = () => {
  const scrollTo = useCallback(
    ({ top = 0, left = 0, behavior = "smooth" } = {}) => {
      // ECRFPage의 스크롤 컨테이너를 찾아서 스크롤
      const scrollContainer = document.querySelector(".ecrf-content");

      if (scrollContainer) {
        // ECRFPage 내부의 스크롤 컨테이너가 있는 경우
        scrollContainer.scrollTo({ top, left, behavior });
      } else {
        // 기본적으로 window 스크롤 사용 (fallback)
        window.scrollTo({ top, left, behavior });
      }
    },
    []
  );
  return [scrollTo];
};
